import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BrowserService} from '@core/service/browser.service';
import {combineLatest, Subject, take, takeUntil} from 'rxjs';
import {MenuComponent} from '@domain/common/layout/menu/menu.component';
import {OverlayComponent} from '@shared/overlay/overlay.component';
import {AuthService} from '@core/auth/auth.service';
import {UmamiService} from '@core/service/umami.service';
import { Meta } from '@angular/platform-browser';
import {environment} from '@environments/environment';
import {NotificationsContainerComponent} from "@shared/notification/notifications-container.component";

@Component({
  selector: 'app-root',
  imports: [RouterModule, MenuComponent, OverlayComponent, NotificationsContainerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'hopla-ui';

  private readonly browserService = inject(BrowserService);
  private readonly authService = inject(AuthService);
  private readonly umamiService = inject(UmamiService);
  private readonly meta = inject(Meta);

  private readonly destroy$ = new Subject<void>();

  private static readonly orientationClasses = ['portrait', 'landscape'];

  public constructor() {

    this.authService.refreshAuthenticatedUser().pipe(
      take(1)
    ).subscribe(_ => {});
    combineLatest([
      this.browserService.breakpoint$,
      this.browserService.isLandscape$,
      this.browserService.routeClasses$
    ]).pipe(
      takeUntil(this.destroy$)
    ).subscribe(([breakpoint, isLandscape, routeClasses]) => {
      if (this.browserService.isBrowser) {
        const classesToAdd: string[] = [...routeClasses];
        classesToAdd.push(breakpoint);
        classesToAdd.push(AppComponent.orientationClasses[+isLandscape]);
        document.body.classList.remove(...document.body.classList);
        document.body.classList.add(...classesToAdd);
      }
    });
  }

  public ngOnInit(): void {
    this.umamiService.init();

    if (environment.googleSiteVerification) {
      this.meta.addTag({ name: 'google-site-verification', content: environment.googleSiteVerification });
    }
    const robotsRule = environment.stack === 'prod' ? 'index, follow' : 'noindex, nofollow';
    this.meta.addTag({ name: 'robots', content: robotsRule });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
